<template>
  <div id="achievement">
    <h2>دستاورد ها</h2>
    
      <div class="row" :key="index" v-for="(item,index) in info">
        <h4>{{ item.name }}</h4>
        <p class="achievement-about">
          {{ item.description }}
        </p>
        <span style="font-size: 1.4rem; margin-bottom: 10px">لینک : </span>

        <br />
        <a
          style="color: #0000ff; text-decoration: none"
          :href="item.link"
          >{{ item.link }}</a
        >
      </div>
      
      

   
  </div>
</template>

<script>
import axios from "axios"
export default {
  beforeCreate: function () {
    document.body.className = "achievements";
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    axios
      .post("https://mohammadrostamidevapi.iran.liara.run/api/v1/achievements", {})
      .then((respose) => (this.info = respose.data))
      .then((error) => console.log(error));
    console.log(this.info)
  },
};
</script>

<style>
#nav-about-li a {
  color: white !important;
}
</style>
